var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.emptyAutomationDetails && !_vm.editMode
    ? _c(
        "div",
        { staticClass: "automation-single-details-container" },
        [
          _vm.loadingStatistics
            ? _c("app-automation-details-loader")
            : _c(
                "div",
                {
                  staticClass:
                    "row automation-details-container position-relative align-items-center py-4 pl-3 bt-1 mt-4",
                },
                [
                  _c("div", { staticClass: "col-auto" }, [
                    _c(
                      "div",
                      { staticStyle: { width: "9rem" } },
                      [
                        _c("template-card", {
                          attrs: {
                            "template-id": _vm.actionArguments.templateId,
                            thumbnail: _vm.actionArguments.templateThumbnail,
                            "template-name": _vm.actionArguments.templateName,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "row align-items-center" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-xl-5 mb-xl-0 mb-3" },
                        [
                          _c("application-automation-statistics", {
                            attrs: {
                              statistics: _vm.statistics,
                              status: _vm.actionArguments.status,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "simple-button",
                            {
                              ref: "downloadCsvButton",
                              attrs: {
                                "class-name": "btn-sm",
                                type: "primary",
                                loading: _vm.downloadingCsv.loading,
                                "loading-succeeded": _vm.downloadingCsv.status,
                              },
                              on: { click: _vm.downloadCsv },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("global.actions.downloadCSV")) +
                                  "\n            "
                              ),
                              _c("i", { staticClass: "fa fa-download pl-2" }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-xl-4 mb-xl-0 mb-3" },
                        [
                          _c("h6", [
                            _c("span", { staticClass: "bold" }, [
                              _vm._v(
                                _vm._s(_vm.$t("global.words.subject")) + ": "
                              ),
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.actionArguments.subject) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("h6", [
                            _c("span", { staticClass: "bold" }, [
                              _vm._v(
                                _vm._s(_vm.$t("campaigns.previewText")) + ": "
                              ),
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.actionArguments.previewText) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.coappHandler.enabled
                            ? _c("div", [
                                _c("h6", { staticClass: "d-inline" }, [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "global.actions.includeCoapplicants"
                                        )
                                      ) + ":"
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    ref: "statusTooltip",
                                    staticClass: "pretty ml-2 p-switch p-fill",
                                    attrs: { "data-placement": "left" },
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.coappHandler.value,
                                          expression: "coappHandler.value",
                                        },
                                      ],
                                      attrs: {
                                        id: _vm.labelFor,
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.coappHandler.value
                                        )
                                          ? _vm._i(
                                              _vm.coappHandler.value,
                                              null
                                            ) > -1
                                          : _vm.coappHandler.value,
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$a = _vm.coappHandler.value,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.coappHandler,
                                                    "value",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.coappHandler,
                                                    "value",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.coappHandler,
                                                "value",
                                                $$c
                                              )
                                            }
                                          },
                                          function ($event) {
                                            return _vm.handleToggleIncludeCoapps(
                                              true
                                            )
                                          },
                                        ],
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "state" }, [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "hidden-text",
                                          attrs: { for: _vm.labelFor },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("global.words.switch")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xl col-12 text-xl-right" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-white",
                              on: { click: _vm.handleViewRecipients },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "automations.applicationLevel.viewUpcomingRecipients"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "fa fa-gear clickable position-absolute",
                    staticStyle: { right: "20px", top: "20px" },
                    attrs: { "aria-hidden": "true" },
                    on: { click: _vm.toggleEditMode },
                  }),
                  _vm._v(" "),
                  _c("upcoming-recipients-modal", {
                    ref: "upcomingRecipientsModal",
                    attrs: { automation: _vm.automation, time: _vm.time },
                  }),
                ],
                1
              ),
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass:
            "automation-details-creation-container position-relative",
        },
        [
          _c(
            "form",
            {
              attrs: { id: "create-app-automation-form" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm.editMode
                ? _c("i", {
                    staticClass: "fa fa-times clickable position-absolute",
                    staticStyle: { right: "20px", top: "20px" },
                    attrs: { "aria-hidden": "true" },
                    on: { click: _vm.toggleEditMode },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.loadingTemplate
                ? _c("app-automation-details-loader")
                : _c(
                    "div",
                    { staticClass: "create-app-automation-container" },
                    [
                      _c("campaign-subject-section", {
                        attrs: {
                          label: false,
                          "subject-data": _vm.subjectData,
                          "template-actions": false,
                        },
                        on: { change: _vm.handleChangeSubject },
                      }),
                      _vm._v(" "),
                      _c("campaign-design-section", {
                        attrs: {
                          label: false,
                          "template-data": _vm.templateData,
                          "select-template-params": _vm.selectTemplateParams,
                        },
                      }),
                      _vm._v(" "),
                      _vm.coappHandler.enabled
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "align-items-baseline justify-content-center row mt-3",
                            },
                            [
                              _c("h6", { staticClass: "d-inline" }, [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "global.actions.includeCoapplicants"
                                      )
                                    ) + ":"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  ref: "statusTooltip",
                                  staticClass: "pretty ml-2 p-switch p-fill",
                                  attrs: { "data-placement": "left" },
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.coappHandler.value,
                                        expression: "coappHandler.value",
                                      },
                                    ],
                                    attrs: {
                                      id: _vm.labelFor,
                                      type: "checkbox",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.coappHandler.value
                                      )
                                        ? _vm._i(_vm.coappHandler.value, null) >
                                          -1
                                        : _vm.coappHandler.value,
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$a = _vm.coappHandler.value,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.coappHandler,
                                                  "value",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.coappHandler,
                                                  "value",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.coappHandler,
                                              "value",
                                              $$c
                                            )
                                          }
                                        },
                                        function ($event) {
                                          return _vm.handleToggleIncludeCoapps(
                                            false
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "state" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "hidden-text",
                                        attrs: { for: _vm.labelFor },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("global.words.switch"))
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-row w-100 justify-content-end mt-1 py-3 pr-3",
                        },
                        [
                          _c(
                            _vm.simpleButtonComponent,
                            {
                              ref: "submitAppAutomationButton",
                              tag: "component",
                              attrs: {
                                "class-name": "btn-sm",
                                type: "primary",
                                page: _vm.currentAccountPlanPage,
                                disabled: !_vm.isValid,
                                loading: _vm.submittingAutomation.loading,
                                "loading-succeeded":
                                  _vm.submittingAutomation.status,
                              },
                              on: { click: _vm.handleSubmit },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("global.words.save")) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }